import {
  ADD_TRUCK_OWNER_FAIL,
  ADD_TRUCK_OWNER_REQUEST,
  ADD_TRUCK_OWNER_SUCCESS,
  DELETE_TRUCK_OWNER_FAIL,
  DELETE_TRUCK_OWNER_REQUEST,
  DELETE_TRUCK_OWNER_SUCCESS,
  GET_SINGLE_TRUCK_OWNER_FAIL,
  GET_SINGLE_TRUCK_OWNER_REQUEST,
  GET_SINGLE_TRUCK_OWNER_SUCCESS,
  GET_TRUCK_OWNER_LIST,
  GET_TRUCK_OWNER_LIST_FAIL,
  GET_TRUCK_OWNER_LIST_SUCCESS,
  UPDATE_TRUCK_OWNER_FAIL,
  UPDATE_TRUCK_OWNER_REQUEST,
  UPDATE_TRUCK_OWNER_SUCCESS,
} from "src/constants/types";

export const truckOwnerReducer = (state = {}, actions) => {
  switch (actions.type) {
    case GET_TRUCK_OWNER_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRUCK_OWNER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        truckOwnerList: actions.payload,
        error: "",
      };
    case GET_TRUCK_OWNER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_TRUCK_OWNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_TRUCK_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_truck_owner: actions.payload,
      };
    case GET_SINGLE_TRUCK_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_TRUCK_OWNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_TRUCK_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_TRUCK_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_TRUCK_OWNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_TRUCK_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_TRUCK_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_TRUCK_OWNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_TRUCK_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_TRUCK_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
